import { shippingClient, operatorClient } from 'domain/HttpClients';

export const fetch = ({ fileName, ...payload }) => shippingClient
  .Post('/api/shipments/createBatchShipmentsFromFile')
  .withData(payload)
  .send();

export const create = (shipments) => operatorClient
  .Post('/api/shipments/assign')
  .withData(shipments)
  .send();

export const upload = ({ fileName, ...payload }) => shippingClient
  .Post('/api/waybills/upload')
  .withData(payload)
  .send();
